import { render } from "./Contact.vue?vue&type=template&id=aeb4e92c&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=aeb4e92c&lang=scss&scoped=true"

import exportComponent from "D:\\eclipse\\workSpaceIDEA\\BioTechLeague_HUIDU_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeb4e92c"]])

export default __exports__